export default "__VITE_ASSET__76b1de09__"